import React, { ReactNode } from 'react';

type Reducer<T> = (
  acc: T,
  child: ReactNode,
  i: number,
  children: ReactNode
) => T;

export const reduce = <T>(children: ReactNode, fn: Reducer<T>, _acc: T) => {
  let acc = _acc;
  React.Children.forEach(children, (child, i) => {
    acc = fn(acc, child, i, children);
  });
  return acc;
};
